import { createApp} from 'vue/dist/vue.esm-bundler'
import ListInputApp from './ListInputApp.vue'
import MembersAddInputApp from './MembersAddInputApp.vue'
import MembersRemovalInputApp from './MembersRemovalInputApp.vue'
import FoundersAddInputApp from './FoundersAddInputApp.vue'

import i18n from '/Modules/Translations/Admin/assets/js/I18n'

const keys = [
    'lists: download validated import',
    'lists: check list data',
    'lists: items last check date',
    'application: project members statistics',
    'application: project required members count',
    'application: project valid members count',
    'lists: upload import',
    'lists: add founder',
    'lists: upload list items info',
    'lists: import template',
    'lists: no items found by filter',
    'lists: no items found by filter description',
    'lists: download list of imported founders',
    'lists: download uploaded founders list',
    'lists: uploaded template error',
    'filters: clear',
    'filters: clear filter',

    // 'lists: add new list item',
    'media: failed to upload. try again',
    'confirm: confirm item',
    'confirm:delete item',
    'upload or select files',
    'media: upload allowed types',
    'max file size',
    'drag file here or',
    'upload it',
    'from computer',
    'lists: upload list items',
    'yes',
    'delete',
    'or',
    'lists: edit item',
    'lists: delete item',
    'lists: validation results',
    'lists: item no',
    'lists: item state',
    'lists: enter search fragment',
    'lists: loading items list',
    //'filter',
    'search',
    'total of',
    'items per page',
    'prev',
    'next',
    'actions title',

    //founders
    'applications:transition application_prepare alternative',

    //members
    'lists: members list',
    'lists: add member',
    'lists: upload members items',
    'lists: upload members items info',
    'lists: membership list submit disclaimer',
    'lists: members import stats',
    'lists: members import state',
    'lists: members import count',
    'lists: members import success',
    'lists: members import failed',
    'polonr: add membership action',
    'lists: check members data',
    'confirm:remove member',
    'lists: remove member',
    'lists: remove member item',
    'lists: add member anyway',

    'lists: upload members removal info',
    'lists: removal members list',
    'lists: upload removal members items',
    'lists: membership removal submit disclaimer',
    'applications: delete list item',
];

class ListInput {
    static init($context = null) {
        let selector = "[data-input='list']";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            let $el = $(element);
            if ($el.data('list_instance')) return;

            let app = null

            switch (element.dataset.listType){
                case 'members':
                    app = createApp(MembersAddInputApp)
                    break
                case 'members-removal':
                    app = createApp(MembersRemovalInputApp)
                    break
                case 'founders':
                    app = createApp(FoundersAddInputApp)
                    break;
                default:
                    app = createApp(ListInputApp)
                    break
            }


            app.config.globalProperties.basePath = function (params){
                if($('base').length){
                    return '';
                }else{
                    return '/'
                }
            }
            i18n.init(keys, app, function (){
                app.mount(element);
            }.bind(this), '/api/')
            $el.data('list_instance', app)
        });
    }

}

ListInput.init()
export default ListInput;